import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
interface AboutSubPageTexts {
  title?: string;
  heroClaimLine1?: string;
  heroClaimLine2?: string;
  bottomClaim?: string;
}

interface AboutSubPageProps {
  subKey?: "management" | "core_values" | "mission_vision";
  heroImageSrc: string;
  heroImageAlt?: string;
  heroClaimLine1?: string;
  heroClaimLine2?: string;
  texts?: AboutSubPageTexts;
  children: React.ReactNode;
  metaTitle?: string;
  metaDescription?: string;
  metaOgUrl?: string;
}

export default function AboutSubPage({
  subKey,
  heroImageSrc,
  heroImageAlt,
  heroClaimLine1: propHeroLine1,
  heroClaimLine2: propHeroLine2,
  texts,
  children,
  metaTitle,
  metaDescription,
  metaOgUrl,
}: AboutSubPageProps) {

  const title = texts?.title ?? "";
  const heroLine1 = texts?.heroClaimLine1 ?? propHeroLine1 ?? "";
  const heroLine2 = texts?.heroClaimLine2 ?? propHeroLine2 ?? "";
  const bottomClaim = texts?.bottomClaim ?? "NetBasis International - drive to excellence with excellent drivers !";

  return (
    <div className="min-h-screen flex flex-col">
      {metaTitle && metaDescription && metaOgUrl && (
        <PageHead title={metaTitle} description={metaDescription} ogUrl={metaOgUrl} />
      )}
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image — gleicher Aufbau wie AboutHero */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImageSrc}
                alt={heroImageAlt || title}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              {/* Claim overlay */}
              <div className="absolute inset-0 z-20 flex flex-col items-center md:items-start justify-center px-6 md:px-10 pointer-events-none">
                <div className="flex flex-col items-center md:pl-10 lg:pl-8 -translate-y-24 md:-translate-y-32 lg:-translate-y-40">
                  <p
                    className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center whitespace-nowrap about-hero-top-slide"
                    style={{
                      fontFamily: '"Open Sans", sans-serif',
                      paddingRight: '0.5rem',
                    }}
                  >
                    <span className="inline">{heroLine1}</span>
                    {heroLine2 && (
                      <>{' '}<span className="inline">{heroLine2}</span></>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Page title + content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>
            {children}
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}